import { DialogManager } from "meta/ui2/dialog/DialogManager";
import virtualPath from "meta/utils/virtualPath";
import { SnackbarLabel } from "screens/ContentTab/features/common/SnackbarLabel";
import { handleEventAlert } from "screens/Root/features/menuTree";
import { logout } from "screens/Root/actions/appActions";
import { openContentUrl, openPatientDetail, openPatientDetailWithUrl, setCurrentContentUrl, showActivePageGuidAction, switchPatient, } from "screens/Root/actions/contentTabActions";
import { useEventsWebEvents } from "screens/Root/webevents/useEventsWebEvents";
import { errorSnackbarOptions } from "meta/utils/snackbars";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import { isDevelopmentMode, messages } from "../../utils/constants";
import { useRootSelector } from "../useAppSelector";
import { setInactivityLogoutActive } from "screens/Root/features/slices/rootSlice";
import { getRootAppWindow } from "meta/utils/getRootAppWindow";
export const useNavigation = () => {
    const { activeTabKey, tabs, isLogged } = useRootSelector();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { handleEventReload } = useEventsWebEvents(enqueueSnackbar);
    // initiates logout procedure
    const handleLogout = () => dispatch(logout());
    const inactivityLogout = () => {
        if (!isLogged)
            return;
        const rootFrame = getRootAppWindow(window);
        Object.keys(tabs).forEach((key) => {
            rootFrame.frames[key].RootCommunicator.autoSaveOnLogout();
        });
        dispatch(setInactivityLogoutActive());
    };
    const handleOpenContentUrl = (url, title, forceLoad) => dispatch(openContentUrl(url, title, undefined, undefined, undefined, forceLoad));
    const handleOpenPatientDetail = (visId, initialTab, loadFromStorage, skipMaximumTabsCheck, isScanned) => dispatch(openPatientDetail(visId, initialTab, loadFromStorage, skipMaximumTabsCheck, isScanned));
    const handleOpenPatientDetailByUrl = (initialUrl) => dispatch(openPatientDetailWithUrl(initialUrl));
    const handleSwitchPatient = (visId, initialTab, isScanned) => dispatch(switchPatient(visId, initialTab, isScanned));
    // opens a url as if clicked on a link in menu
    // includes deleting patient info, possibly opening new tab and clearing the tab title
    const setWindowLocation = (url) => dispatch(setCurrentContentUrl(url));
    const getCurrentIframe = () => {
        return window.frames[activeTabKey];
    };
    // changes the current tab's url to the specified one without changing anything else
    // use instead of assigning to window.location
    const openUrl = (href, title, onDone) => {
        if (href.includes("[windowOpen]")) {
            // expected url like:  [windowOpen]:800:600@/Profile.aspx
            //                     [windowOpen]@/Profile.aspx
            const windowOpenHref = href.substring(href.indexOf("[windowOpen]"));
            const [, w, h] = windowOpenHref.split("@")[0].split(":");
            const url = windowOpenHref.split("@")[1];
            DialogManager().GlobalDialog.windowOpen(url, Number(w), Number(h));
        }
        else if (href.startsWith("[tabOpen]")) {
            const [, urlTitle, locked, docked, forceLoad] = href
                .split("@")[0]
                .split(":");
            const url = href.split("@")[1];
            dispatch(openContentUrl(url, (urlTitle || title), Boolean(locked), Boolean(docked), undefined, Boolean(forceLoad)));
        }
        else if (href.startsWith("#")) {
            const handleEventNotFound = () => enqueueSnackbar(<SnackbarLabel>{messages.eventNotFound}</SnackbarLabel>, errorSnackbarOptions);
            handleEventAlert(href.substring(1), virtualPath + "/", () => {
                onDone && onDone();
                handleEventReload();
            }, handleEventNotFound);
        }
        else {
            dispatch(openContentUrl(href, title));
        }
    };
    const showActivePageGuid = () => {
        if (isDevelopmentMode) {
            dispatch(showActivePageGuidAction());
        }
    };
    return {
        logout: handleLogout,
        openUrl,
        openPatientDetail: handleOpenPatientDetail,
        openPatientDetailByUrl: handleOpenPatientDetailByUrl,
        openContentUrl: handleOpenContentUrl,
        switchPatient: handleSwitchPatient,
        getCurrentIframe,
        setWindowLocation,
        showActivePageGuid,
        inactivityLogout
    };
};
